import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AdminCtx = createContext({ admin: null, loading: true });

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/admin/auth/me");
      setAdmin(data);
    } catch {
      setAdmin(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/admin/auth/login", { email, password });
    setAdmin(data.admin);
    return data.admin;
  };

  const logout = async () => {
    await api.post("/admin/auth/logout");
    setAdmin(null);
  };

  return <AdminCtx.Provider value={{ admin, loading, login, logout, refresh }}>{children}</AdminCtx.Provider>;
}

export const useAdmin = () => useContext(AdminCtx);
